import React from "react";
import theme from "@adsk/alloy-react-theme";

export const CharacterCount = ({
  count,
  maxLength,
  style,
}: {
  count: number;
  maxLength: number;
  style: object;
}) => {
  const hasOverflowed = count > maxLength;
  return (
    <span
      data-testid="character-count-values"
      style={{
        ...theme.typography.labelSmall,
        color: theme.colors.charcoal700,
        pointerEvents: "none",
        ...style,
      }}
    >
      <span
        style={{
          ...(hasOverflowed && {
            color: theme.colors.red600,
          }),
        }}
      >
        {count}
      </span>
      {`/${maxLength}`}
    </span>
  );
};
